import React, { useEffect, useState } from "react";
import SimpleSortableTable from "../../../../components/Organismos/Table/SimpleSortableTable";
import Button from "../../../../components/staff/Button";
import { PAYMENT_HISTORY_COLUMNS } from "../constants";
import { useEditParticipantAudit } from "../hooks/useEditParticipantAudit";
import { selectRegistrationId } from "../editParticipant.selectors";
import { useSelector } from "react-redux";

const PAYMENT_HISTORY_PAGE_SIZE = 10;

export default function PaymentHistorySection (): React.ReactElement {
  const registrationId = useSelector(selectRegistrationId);
  const {
    paymentHistoryRows,
    isLoadingAuditLogs,
    showLoadMoreAuditHistory,
    setAuditHistoryExpanded,
  } = useEditParticipantAudit();
  const [visibleCount, setVisibleCount] = useState(PAYMENT_HISTORY_PAGE_SIZE);

  useEffect(() => {
    setVisibleCount(PAYMENT_HISTORY_PAGE_SIZE);
  }, [registrationId]);

  const visibleRows = paymentHistoryRows.slice(0, visibleCount);
  const hasMore = paymentHistoryRows.length > visibleCount;

  return (
    <div>
      <div className="flex items-center justify-between gap-4 mb-4">
        <h3 className="text-secondary">
          Payment History
        </h3>
        {showLoadMoreAuditHistory && (
          <Button
            text="Load more (3 years)"
            onClick={() => setAuditHistoryExpanded(true)}
            color="secondary"
            variant="outlined"
            size="fixed"
            disabled={isLoadingAuditLogs || !registrationId}
          />
        )}
      </div>
      <SimpleSortableTable
        columns={PAYMENT_HISTORY_COLUMNS}
        data={visibleRows}
        emptyMessage={
          isLoadingAuditLogs
            ? "Loading history..."
            : "No payment history yet"
        }
        defaultSorting={{ field: "index", order: "asc" }}
      />
      {hasMore && (
        <div className="flex justify-center my-1">
          <button
            type="button"
            onClick={() =>
              setVisibleCount((count) => count + PAYMENT_HISTORY_PAGE_SIZE)
            }
            className="text-xs text-secondary-dark hover:text-secondary-dark/80"
            disabled={isLoadingAuditLogs}
          >
            Load more
          </button>
        </div>
      )}
    </div>
  );
}
